<template>
  <!-- 海管家 -->
  <div class="sea-house-vgm">
    <div style="display: grid">
      <div class="section form-column" style="width: 100%; display: initial;padding-top: 10px;">
        <el-upload
          no="vgmImportExcel"
          :disabled="readonly"
          :data="{ mbl: job.mbl, vgmChannel: job.vgmChannel, jobUuid: job.uuid, jobNo: job.jobNo }"
          :action="URL.seaExport.vgmImportExcel"
          :headers="{ sessionId: $store.getters.userInfo.sessionId }"
          :show-file-list="false"
          accept=".xls, .xlsx"
          :before-upload="beforeUpload"
          :on-success="uploadSuccess"
          style="display: inline-block; margin-left: 5px;"
        >
          <el-button
            slot="trigger"
            no="excelImport"
            :disabled="readonly"
            type="primary"
          >{{ $t('SeaExport.ExcelImport') }}</el-button>
        </el-upload>
        <!--<el-button no="onDownloadTemplate" style="margin-left: 10px; height: 28px;" type="primary" @click="onDownloadTemplate">{{ $t('CargoMsg.Cargo_DownLoad_Template') }}</el-button>-->
        <el-button
          type="primary"
          style="margin-left: 5px"
          @click="commandHandle($t('SeaExport.DownloadCWTemplate'))"
        >
          {{ $t('SeaExport.DownloadCWTemplate') }}
        </el-button>
        <!--        <el-dropdown-->
        <!--          no="onDownloadTemplate"-->
        <!--          style="margin-left: 5px"-->
        <!--          split-button-->
        <!--          type="primary"-->
        <!--          @click="commandHandle(command)"-->
        <!--          @command=" p => { command = p;commandHandle(command) }"-->
        <!--        >-->
        <!--          {{ command }}-->
        <!--          <el-dropdown-menu slot="dropdown">-->
        <!--            <el-dropdown-item :command="$t('SeaExport.DownloadSeaHouseTemplate')">{{ $t('SeaExport.DownloadSeaHouseTemplate') }}</el-dropdown-item>-->
        <!--            <el-dropdown-item :command="$t('SeaExport.DownloadWseTemplateVgm')">{{ $t('SeaExport.DownloadWseTemplateVgm') }}</el-dropdown-item>-->
        <!--          </el-dropdown-menu>-->
        <!--        </el-dropdown>-->
        <el-button no="showLog" style="margin-left: 10px; height: 28px;" type="primary" @click="showLog">{{ $t('CargoMsg.Cargo_VGMLog') }}</el-button>
        <el-button no="sendVgm" :disabled="!readonly" style="margin-left: 10px; height: 28px;" type="primary" @click="sendVgm">{{ $t('CargoMsg.Cargo_SendVGM') + countdownMsg }}</el-button>
        <el-button no="onOperationGuide" style="margin-left: 10px; height: 28px;" type="primary" @click="onOperationGuide">{{ $t('SeaExport.OperationGuide') }}</el-button>
      </div>
      <div class="section form-column" style="width: 100%; display: initial;padding-top: 10px;margin-left: 0px;">
        <span class="title">{{ $t('CargoMsg.Cargo_VGMChannel') }}：</span>
        <el-radio-group v-model="localVgmChannel" no="vgmChannel" :disabled="readonly">
          <el-radio
            v-for="option in vgmChannels"
            :key="option.code"
            :label="option.code"
          >{{ option.chineseName }}</el-radio>
        </el-radio-group>
      </div>
      <div class="section" style="min-height: 210px">
        <el-form
          label-width="100px"
          label-position="right"
          :disabled="readonly"
          :rules="rules"
          inline
        >
          <div>
            <span class="title">{{ $t('CargoMsg.Cargo_VGMBasicInfo') }}</span>
            <el-button no="syncInfo" :disabled="readonly" style="margin-left: 10px; height: 28px;" type="primary" @click="syncInfo">{{ $t('SeaExport.Synchronization') }}</el-button>
            <i class="el-icon-info" style="margin-left: 10px; margin-top: 5px; font-size: 20px;color: #1F75D5;" :title="$t('CargoMsg.Cargo_IfYouHaveSentPreStowageManifest') + $t('CargoMsg.Cargo_IfYouHaveNotSentPreStowageManifest')" />
          </div>
          <div style="display: flex; gap: 20px;">
            <div style="flex: 1;">
              <cargo-ag-grid
                :show-side-bar="false"
                config-module="11001212"
                :grid-options="gridOptions"
                :column-defs="vgmGroupColumnDefs"
                :row-data="vgmInfoList"
                style="width:100%;height:200px"
                @gridReady="params=>{gridOptions.gridApi=params.api}"
                @grid-ready="onGridReady"
              />
              <div style="display: flex; justify-content: flex-end; gap: 10px;">
                <el-button no="add" type="primary" @click="addVgmInfo">{{ $t('Pricing.Add') }}</el-button>
                <el-button no="isDelete" type="danger" @click="deleteVgmInfo">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
              </div>
            </div>
            <div style="flex: 3;">
              <el-form-item class="required-label" :label="$t('SeaExport.PortOfLoading')" prop="portOfLoading">
                <cargo-advance-select
                  no="portOfLoading"
                  :static-options="cachePortList"
                  :cache="false"
                  :default-value="vgmInfo.portOfLoading"
                  filterable
                  clearable
                  :filter-tag-names="['name', 'code', 'chineseName']"
                  tag-name="name"
                  tag-value="code"
                  filter-type="global"
                  :placeholder="portOfLoadingPlaceholder"
                  @parentCallBack="changePort"
                />
                <p class="input-tips">{{ $t('CargoMsg.Cargo_FriendlyReminderWithPort') }}</p>
              </el-form-item>
              <el-form-item class="required-label" :label="$t('SeaExport.ShippingCompany')" prop="shippingCompany">
                <cargo-advance-select
                  no="shPorts"
                  :static-options="vgmCarriers || []"
                  :cache="false"
                  :default-value="vgmInfo.thirdPartyCarrier"
                  filterable
                  clearable
                  :filter-tag-names="['name', 'code', 'chineseName']"
                  tag-name="name"
                  tag-value="code"
                  filter-type="global"
                  :placeholder="thirdPartyCarrierPlaceholder"
                  @parentCallBack="changeCarrier"
                />
              </el-form-item>
              <el-form-item class="required-label" label="MBL NO" prop="mbl">
                <el-input ref="mbl" v-model="vgmInfo.mbl" no="mbl" :maxlength="30" @blur="handleMblInput" />
                <p class="input-tips">{{ $t('CargoMsg.Cargo_FriendlyReminder') }}</p>
              </el-form-item>
              <el-form-item v-show="isRongETong ? (isSHPort || isQDPort) : isSHPort" :class="((isRongETong && isSHPort) || (!isRongETong && isSHPort)) ? 'required-label' : ''" :label="$t('SeaExport.Wharf')" prop="wharf">
                <cargo-advance-select
                  no="wharf"
                  :static-options="cacheWharfs || []"
                  :cache="false"
                  :default-value="vgmInfo.wharf"
                  filterable
                  clearable
                  :filter-tag-names="['name', 'code', 'chineseName']"
                  tag-name="name"
                  tag-value="code"
                  filter-type="global"
                  @parentCallBack="p=>{vgmInfo.wharf=p.value}"
                />
                <p class="input-tips">{{ $t('CargoMsg.Cargo_TerminalInfoForReferenceOnly') + (this.isWse ? $t('CargoMsg.Cargo_TerminalInfoForReferenceWse') : '') }}</p>
              </el-form-item>
              <el-form-item v-show="showSoNo" class="required-label" label="SO NO" prop="soNo">
                <el-input v-model="vgmInfo.soNo" no="soNo" @blur="handleSoNoInput" />
              </el-form-item>
              <el-form-item v-show="showVesselAndVoyage" class="required-label" :label="$t('SeaExport.Vessel')" prop="vessel">
                <el-input v-model="vgmInfo.vessel" no="vessel" @input="toUpperCase('vessel')" @blur="loadWharf" />
              </el-form-item>
              <el-form-item v-show="showVesselAndVoyage" class="required-label" :label="$t('SeaExport.Voyage')" prop="voyage">
                <el-input v-model="vgmInfo.voyage" no="voyage" @input="toUpperCase('voyage')" @blur="loadWharf" />
              </el-form-item>
              <el-form-item v-show="showVgmCutOffDate" class="required-label" :label="$t('CargoMsg.Cargo_VGMCutOffDate')" prop="vgmCutOffDate">
                <el-date-picker
                  v-model="vgmInfo.vgmCutOffDate"
                  no="vgmCutOffDate"
                  type="datetime"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                />
                <p class="input-tips">{{ $t('CargoMsg.Cargo_FriendlyReminderWithCutOffTime') }}</p>
              </el-form-item>
              <el-form-item v-show="isQDPort" class="required-label" :label="$t('SeaExport.Yard')" prop="station">
                <cargo-advance-select
                  no="station"
                  :static-options="cacheYards || []"
                  :cache="false"
                  :default-value="vgmInfo.yard"
                  filterable
                  clearable
                  :filter-tag-names="['name', 'code', 'chineseName']"
                  tag-name="name"
                  tag-value="code"
                  filter-type="global"
                  @parentCallBack="p=>{vgmInfo.yard=p.value}"
                />
              </el-form-item>
              <el-form-item class="required-label" :label="$t('CargoMsg.Cargo_ContainerHolder')">
                <el-radio-group v-model="vgmInfo.boxHolder" no="boxHolder" style="display: block;">
                  <el-radio
                    v-for="option in boxHolders"
                    :key="option.code"
                    :label="option.code"
                    style="display: block; margin-bottom: 8px;"
                  >{{ option.chineseName }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="isRongETong && isQDPort" class="required-label" :label="$t('SeaExport.SendingChannelVgm')">
                <el-radio-group v-model="vgmInfo.sendChannel" no="sendChannel" style="display: block;">
                  <el-radio
                    v-for="option in vgmSendChannels"
                    :key="option.code"
                    :label="option.code"
                    style="display: block; margin-bottom: 8px;"
                  >{{ option.chineseName }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>

        </el-form>
      </div>
    </div>
    <div class="main-content section">
      <span class="title">{{ $t('SeaExport.CargoInfo') }}</span>
      <p style="color: red">{{ $t('CargoMsg.Cargo_TheShipperDeclares') }}</p>
      <div class="operations">
        <div class="triggers">
          <div>
            <el-button no="addVgmContainer" :disabled="readonly" type="primary" @click="addVgmContainer">{{ $t('Payment.new') }}</el-button>
            <el-button no="removeVgmContainer" :disabled="readonly" type="danger" @click="removeVgmContainer">{{ $t('FileHistory.Delete') }}</el-button>
            <el-button
              no="importFromContainer"
              :disabled="readonly"
              type="primary"
              @click="importFromContainer(true)"
            >{{ $t('SeaExport.GetPackingInformation') }}</el-button>
          </div>
        </div>
      </div>
      <div v-if="!showVGMWeightAddress" class="section grid-wrapper" style="height: 100%">
        <cargo-ag-grid
          no="vgmGrid"
          config-module="150114"
          :grid-options="vgmGrid.gridOptions"
          :column-defs="vgmGridColumnDefs2"
          :row-data="vgmInfo.vgmContainers"
          style="width:100%;margin-top:5px;"
          @gridReady="params=>{vgmGrid.gridOptions.gridApi=params.api}"
        />
      </div>
      <div v-if="showVGMWeightAddress" class="section grid-wrapper" style="height: 100%">
        <cargo-ag-grid
          no="vgmGrid"
          config-module="150124"
          :grid-options="vgmGrid.gridOptions"
          :column-defs="vgmGridColumnDefs"
          :row-data="vgmInfo.vgmContainers"
          style="width:100%;margin-top:5px;"
          @gridReady="params=>{vgmGrid.gridOptions.gridApi=params.api}"
        />
      </div>
    </div>
    <!--    <div v-if="!isWse" class="sea-house-tip" @click="linkQQ">-->
    <!--      <img src="@/assets/icons/sea-house-icon.png" :title="$t('SeaExport.YouServiceOfTheManifest')">-->
    <!--    </div>-->
    <vgm-service-guide
      v-if="vgmServiceGuide.visible"
      :visible.sync="vgmServiceGuide.visible"
      :ports="wseCache.portList"
      :vgm-carriers="mergeVgmCarriers"
      @close="vgmServiceGuide.visible = false"
    />
    <vgm-log
      v-if="vgmLog.visible"
      :visible.sync="vgmLog.visible"
      :job-uuid="job.uuid"
      :sea-house-cache="seaHouseCache"
      @close="vgmLog.visible = false"
    />
  </div>
</template>

<script>
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache } from '@/utils/basicDataCache'
import { getLoading } from '@/utils/utilBaseElement'
import { querySeaHouseWharf, sendVgm, vgmList } from '@/api/seaExport/vgm'
import { VgmContainer } from '@/class/model/booking/VgmContainer'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import * as commonUtils from '@/utils/commonUtil'
import { ThirdPartyMappingUtil } from '@/class/cargo/model/utils/ThirdPartyMappingUtil'
import { VgmInfo } from '@/class/model/booking/VgmInfo'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import VgmWeighingMethodHeader from '@/views/cargo/v0/SeaExport/components/booking/vgm/VgmWeighingMethodHeader'
import URL from '@/api/urlTranslator'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import VgmLog from '@/views/cargo/v0/SeaExport/components/booking/vgm/vgmLogDialog'
import VgmServiceGuide from '@/views/cargo/v0/SeaExport/components/booking/vgm/vgmServiceGuideDialog'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { deepCopy } from '@/utils/commonUtil'
import { validUserCode } from '@/utils/validate'

export default {
  name: 'SeaHouseVgm',
  components: { VgmLog, VgmServiceGuide, CargoAdvanceSelect },
  props: {
    job: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      required: true,
      default: false
    },
    isEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    vasChannel: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data() {
    var validatorPortOfLoading = (rule, value, callback) => {
      if (!this.vgmInfo.portOfLoading) {
        return callback(new Error(this.$t('CargoMsg.Cargo_PleaseSelect')))
      }
    }
    var validatorShippingCompany = (rule, value, callback) => {
      if (!this.vgmInfo.thirdPartyCarrier) {
        return callback(new Error(this.$t('CargoMsg.Cargo_pleaseSelectAShippingCompany')))
      }
    }
    var validatorMbl = (rule, value, callback) => {
      if (!validUserCode(this.vgmInfo.mbl) || this.vgmInfo.mbl.length < 6 || this.vgmInfo.mbl.length > 30) {
        return callback(new Error(this.$t('CargoMsg.Cargo_MblTip')))
      }
    }
    var validatorWharf = (rule, value, callback) => {
      if (!this.vgmInfo.wharf) {
        return callback(new Error(this.$t('CargoMsg.Cargo_PleaseSelect')))
      }
    }
    var validatorVessel = (rule, value, callback) => {
      if (!this.vgmInfo.vessel) {
        return callback(new Error(this.$t('CargoMsg.Cargo_PlsInput')))
      }
    }
    var validatorVoyage = (rule, value, callback) => {
      if (!this.vgmInfo.voyage) {
        return callback(new Error(this.$t('CargoMsg.Cargo_PlsInput')))
      }
    }
    var validatorSoNo = (rule, value, callback) => {
      if (!this.vgmInfo.soNo) {
        return callback(new Error(this.$t('CargoMsg.Cargo_PlsInput')))
      }
    }
    var validatorVgmCutOffDate = (rule, value, callback) => {
      if (!this.vgmInfo.vgmCutOffDate) {
        return callback(new Error(this.$t('CargoMsg.Cargo_PleaseSelect')))
      }
    }
    return {
      URL,
      loading: false,
      vgmChannels: SeaExportConstants.VGM_CHANNELS,
      boxHolders: SeaExportConstants.BOX_HOLDERS,
      vgmSendChannels: SeaExportConstants.VGM_SEND_CHANNELS,
      vgmInfoRaw: new VgmInfo().fillDefaultValue().getData(), // 原始vgmInfo
      vgmInfoList: [],
      vgmInfo: new VgmInfo().fillDefaultValue().getData(),
      totalTime: 60, // 发送按钮倒计时
      seaHouseCache: {
        load: false,
        portList: [], // 船代
        vgmCarriers: [], // vgm船公司
        shPorts: [], // 运输条款
        externalPorts: [], // 船公司
        weighingMethods: [], // 货物类型
        wharfs: [], // 运费条款
        seaports: [], // 海港
        blModeList: [] // 提单方式
      },
      portOfLoadingPlaceholder: this.$t('CargoMsg.Cargo_PleaseSelect'),
      thirdPartyCarrierPlaceholder: this.$t('CargoMsg.Cargo_PleaseSelect'),
      vgmServiceGuide: {
        visible: false
      },
      vgmLog: {
        visible: false
      },
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: false,
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
          // this.ams2.isSelected = false
        },
        context: {
          componentParent: this
        },
        onRowClicked: this.clickedVgmInfo,
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        },
        gridApi: null
      },
      delVgmKeys: [],
      delVgmContainerKeys: [],
      vgmGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor,
            VgmWeighingMethodHeader
          },
          // 单击显示编辑
          singleClickEdit: true,
          gridApi: null
        },
        rowData: [],
        gridApi: null
      },
      showVGMWeightAddress: false,
      mergeVgmCarriers: [],
      wseCache: { // 未斯
        load: false,
        portList: [], // 船代
        vgmCarriers: [], // vgm船公司
        shPorts: [], // 运输条款
        externalPorts: [], // 船公司
        weighingMethods: [], // 货物类型
        wharfs: [], // 码头
        seaports: [], // 海港
        blModeList: [], // 提单方式
        QDBoxes: [], // 箱型
        QDYards: [] // 场站
      },
      rongETongCache: { // 荣e通
        load: false,
        portList: [], // 船代
        vgmCarriers: [], // vgm船公司
        shPorts: [], // 运输条款
        externalPorts: [], // 船公司
        weighingMethods: [], // 货物类型
        wharfs: [], // 码头
        seaports: [], // 海港
        blModeList: [], // 提单方式
        QDBoxes: [], // 箱型
        QDYards: [] // 场站
      },
      weighingMethods: [{ code: 'SM1', value: 'SM1' }, { code: 'SM2', value: 'SM2' }],
      command: this.$t('SeaExport.DownloadTemplate'),
      rules: {
        portOfLoading: [
          { validator: validatorPortOfLoading, trigger: 'change' }
        ],
        shippingCompany: [
          { validator: validatorShippingCompany, trigger: 'change' }
        ],
        mbl: [
          { validator: validatorMbl, trigger: 'blur' }
        ],
        wharf: [
          { validator: validatorWharf, trigger: 'change' }
        ],
        vessel: [
          { validator: validatorVessel, trigger: 'blur' }
        ],
        voyage: [
          { validator: validatorVoyage, trigger: 'blur' }
        ],
        soNo: [
          { validator: validatorSoNo, trigger: 'blur' }
        ],
        vgmCutOffDate: [
          { validator: validatorVgmCutOffDate, trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    pickerOptions() {
      // 获取今天的日期
      const today = new Date()
      // 构建禁用时间的函数
      const disabledDate = time => {
        // 如果待选时间是今天的日期，返回 false，表示可选
        if (time.getFullYear() === today.getFullYear() && time.getMonth() === today.getMonth() && time.getDate() === today.getDate()) {
          return false
        }
        return time.getTime() < today.getTime()
      }
      // 返回日期选择器的选项配置
      return {
        disabledDate
      }
    },
    showVgmCutOffDate() {
      return ['HMM', 'CMA', 'MSK', 'HAL'].indexOf(this.vgmInfo.thirdPartyCarrier) > -1
    },
    isSHPort() {
      return this.vgmInfo.portOfLoading === '上海'
    },
    isQDPort() {
      return this.vgmInfo.portOfLoading === '青岛'
    },
    showSoNo() {
      return ['WHL', 'HLC', 'HLC/HPL'].indexOf(this.vgmInfo.thirdPartyCarrier) > -1
    },
    showVesselAndVoyage() {
      return this.isSHPort || (this.vgmInfo.portOfLoading === '青岛' && ['ZIM', 'GSL'].indexOf(this.vgmInfo.thirdPartyCarrier) > -1)
    },
    mustInputVGMWeightAddress() {
      return this.isSHPort && this.vgmInfo.thirdPartyCarrier === 'APL'
    },
    countdownMsg() {
      if (this.totalTime === 60) {
        return ''
      }
      return ' (' + this.totalTime + 'S)'
    },
    vgmCarriers() {
      if (!this.vgmInfo.portOfLoading) {
        return []
      }
      return this.cacheVgmCarriers.filter(item => item.filterValue.indexOf(this.vgmInfo.portOfLoading) > -1)
    },
    localVgmChannel: {
      get() {
        return this.job.vgmChannel === 0 ? 0 : 1
      },
      set(value) {
        if (value === 1) {
          this.vasChannel === 0 ? this.job.vgmChannel = SeaExportConstants.VGM_CHANNEL_WSE.code : this.job.vgmChannel = this.vasChannel
        } else {
          this.job.vgmChannel = 0
        }
        return value
      }
    },
    vgmGridColumnDefs() {
      let columnDefs
      columnDefs = [
        {
          headerName: '',
          colId: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNo',
          flex: 1,
          editable: params => { return this.isEdit },
          cellEditor: 'CargoAgGridCommonInputEditor',
          width: 100,
          headerClass: () => {
            return 'required-label'
          },
          onCellValueChanged: params => {
            this.changeContainerNo(params)
          }
        },
        {
          headerName: this.$t('SeaExport.VgmWeight'),
          field: 'vgmWeight',
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          flex: 1,
          width: 100,
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          headerClass: () => {
            return 'required-label'
          },
          onCellValueChanged: params => {
            this.changeVgmWeight(params)
          }
        },
        {
          headerName: this.$t('SeaExport.VgmWeighingMethod'),
          hide: true,
          headerComponent: 'VgmWeighingMethodHeader',
          field: 'vgmWeightingMethod',
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              filterable: true,
              tagName: 'code',
              tagValue: 'code',
              filterTagNames: ['code'],
              staticOptions: this.isRongETong ? this.weighingMethods : this.seaHouseCache.weighingMethods
            }
          },
          valueFormatter: params => {
            const weighingMethods = this.isRongETong ? this.weighingMethods : this.seaHouseCache.weighingMethods
            for (const data of weighingMethods) {
              if (data.code === params.value) {
                return data.code
              }
            }
            return ''
          },
          width: 160,
          headerClass: () => {
            return 'required-label'
          }
        },
        {
          headerName: this.$t('SeaExport.VGMLLC'),
          field: 'vgmLiabilityCompany',
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          flex: 1,
          width: 100,
          // headerClass: () => {
          //   return 'required-label'
          // },
          onCellValueChanged: params => {
            this.changeVgmLiabilityCompany(params)
          }
        },
        {
          headerName: this.$t('SeaExport.VGMWeightAddress'),
          field: 'weighingAddress',
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          flex: 1,
          width: 100,
          headerClass: () => {
            return 'required-label'
          },
          onCellValueChanged: params => {
            this.changeVGMWeightAddress(params)
          }
        },
        {
          headerName: this.$t('SeaExport.VGMSignature'),
          field: 'vgmAutoGraph',
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          flex: 1,
          width: 100,
          // headerClass: () => {
          //   return 'required-label'
          // },
          onCellValueChanged: params => {
            this.changeVGMSignature(params)
          }
        }
      ]
      if (this.isRongETong && (this.vgmInfo.thirdPartyCarrier === 'YML' || this.vgmInfo.thirdPartyCarrier === 'MAT')) {
        const columnDefsRongETong = [
          {
            headerName: this.$t('SeaExport.Weight'),
            field: 'grossWeight',
            editable: this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            flex: 1,
            width: 100,
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                controls: false,
                precision: 3
              }
            },
            headerClass: () => {
              return 'required-label'
            },
            onCellValueChanged: params => {
              this.changeVgmGrossWeight(params)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_TareWeight'),
            field: 'tareWeight',
            editable: this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            flex: 1,
            width: 100,
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                controls: false,
                precision: 3
              }
            },
            headerClass: () => {
              return 'required-label'
            },
            onCellValueChanged: params => {
              this.changeVgmTareWeight(params)
            }
          }
        ]
        columnDefs = [...columnDefs, ...columnDefsRongETong]
      }
      return columnDefs
    },
    vgmGridColumnDefs2() {
      let columnDefs
      columnDefs = [
        {
          headerName: '',
          colId: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNo',
          flex: 1,
          editable: params => { return this.isEdit },
          cellEditor: 'CargoAgGridCommonInputEditor',
          width: 100,
          headerClass: () => {
            return 'required-label'
          },
          onCellValueChanged: params => {
            this.changeContainerNo(params)
          }
        },
        {
          headerName: this.$t('SeaExport.VgmWeight'),
          field: 'vgmWeight',
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          flex: 1,
          width: 100,
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          headerClass: () => {
            return 'required-label'
          },
          onCellValueChanged: params => {
            this.changeVgmWeight(params)
          }
        },
        {
          headerName: this.$t('SeaExport.VgmWeighingMethod'),
          hide: true,
          headerComponent: 'VgmWeighingMethodHeader',
          field: 'vgmWeightingMethod',
          editable: this.isEdit,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              filterable: true,
              tagName: 'code',
              tagValue: 'code',
              filterTagNames: ['code'],
              staticOptions: this.isRongETong ? this.weighingMethods : this.seaHouseCache.weighingMethods
            }
          },
          valueFormatter: params => {
            const weighingMethods = this.isRongETong ? this.weighingMethods : this.seaHouseCache.weighingMethods
            for (const data of weighingMethods) {
              if (data.code === params.value) {
                return data.code
              }
            }
            return ''
          },
          width: 160,
          headerClass: () => {
            return 'required-label'
          }
        },
        {
          headerName: this.$t('SeaExport.VGMLLC'),
          field: 'vgmLiabilityCompany',
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          flex: 1,
          width: 100,
          // headerClass: () => {
          //   return 'required-label'
          // },
          onCellValueChanged: params => {
            this.changeVgmLiabilityCompany(params)
          }
        },
        {
          headerName: this.$t('SeaExport.VGMSignature'),
          field: 'vgmAutoGraph',
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          flex: 1,
          width: 100,
          // headerClass: () => {
          //   return 'required-label'
          // },
          onCellValueChanged: params => {
            this.changeVGMSignature(params)
          }
        }
      ]
      if (this.isRongETong && (this.vgmInfo.thirdPartyCarrier === 'YML' || this.vgmInfo.thirdPartyCarrier === 'MAT')) {
        const columnDefsRongETong = [
          {
            headerName: this.$t('SeaExport.Weight'),
            field: 'grossWeight',
            editable: this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            flex: 1,
            width: 100,
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                controls: false,
                precision: 3
              }
            },
            headerClass: () => {
              return 'required-label'
            },
            onCellValueChanged: params => {
              this.changeVgmGrossWeight(params)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_TareWeight'),
            field: 'tareWeight',
            editable: this.isEdit,
            cellEditor: 'CargoAgGridCommonInputEditor',
            flex: 1,
            width: 100,
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                controls: false,
                precision: 3
              }
            },
            headerClass: () => {
              return 'required-label'
            },
            onCellValueChanged: params => {
              this.changeVgmTareWeight(params)
            }
          }
        ]
        columnDefs = [...columnDefs, ...columnDefsRongETong]
      }
      if (this.isQDPort) {
        const columnDefsQD = [
          { headerName: this.$t('SeaExport.ContainerSize'),
            field: 'containerType',
            colId: 'containerType',
            width: 200,
            flex: 1,
            editable: true,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: () => ({
              selectProps: {
                tagValue: 'code',
                tagName: 'name',
                staticOptions: this.isRongETong ? this.rongETongCache.QDBoxes : this.wseCache.QDBoxes,
                filterable: true
              }
            }),
            headerClass: () => {
              return 'required-label'
            },
            valueFormatter: (params) => {
              if (this.isRongETong) {
                return params.value
              }
              return this.resolveContainerType(params)
            }
          }
        ]
        columnDefs = [...columnDefs, ...columnDefsQD]
      }
      return columnDefs
    },
    vgmGroupColumnDefs() {
      return [
        {
          headerName: this.$t('SeaExport.SequenceNumber'),
          sortable: false,
          suppressMenu: true,
          width: 30,
          valueGetter: params => {
            return params.node.rowIndex + 1
          }
        },
        {
          headerName: this.$t('SeaExport.RefNo'),
          sortable: false,
          suppressMenu: true,
          colId: 'referenceNo',
          field: 'referenceNo',
          flex: 1,
          editable: params => { return this.isEdit },
          cellEditor: 'CargoAgGridCommonInputEditor',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ReceiptStatus'),
          sortable: false,
          suppressMenu: true,
          colId: 'receiptStatus',
          field: 'receiptStatus',
          flex: 1,
          width: 100,
          cellRenderer: params => {
            if (!params.data?.receiptStatus) {
              return this.$t('SeaExport.NotSent')
            } else if (params.data?.receiptStatus === 'S') {
              return `<span>${this.$t('SeaExport.hasBeanSend')}</span>`
            } else if (params.data?.receiptStatus === 'T') {
              return `<span style="color: green">${this.$t('SeaExport.receiptSucceeded')}</span>`
            } else if (params.data?.receiptStatus === 'F') {
              return `<span style="color: red">${this.$t('SeaExport.receiptFailed')}</span>`
            } else if (params.data?.receiptStatus === 'C') {
              return `<span style="color: red">${this.$t('CargoMsg.Cargo_Chargeback')}</span>`
            }
          }
        }
      ]
    },
    isWse() { // 未斯
      return this.job.vgmChannel === SeaExportConstants.VGM_CHANNEL_WSE.code
    },
    isRongETong() { // 荣e通
      return this.job.vgmChannel === SeaExportConstants.VGM_CHANNEL_RONGE_TONG.code
    },
    cachePortList() {
      if (this.isRongETong) {
        return this.rongETongCache.portList
      } else if (this.isWse) {
        return this.wseCache.portList
      }
      return this.seaHouseCache.portList
    },
    cacheVgmCarriers() {
      if (this.isRongETong) {
        return this.rongETongCache.vgmCarriers
      } else if (this.isWse) {
        return this.wseCache.vgmCarriers
      }
      return this.seaHouseCache.vgmCarriers
    },
    cacheWharfs() {
      if (this.isRongETong) {
        return this.isSHPort ? this.rongETongCache.wharfs.filter(t => t.filterValue === 'sh') : this.rongETongCache.wharfs.filter(t => t.filterValue === 'qd')
      } else if (this.isWse) {
        return this.wseCache.wharfs
      }
      return this.seaHouseCache.wharfs
    },
    cacheYards() {
      if (this.isWse) {
        return this.wseCache.QDYards
      }
      return this.rongETongCache.QDYards
    }
  },
  watch: {
    'job.vgmChannel': function(newVal) {
      // LocalStorageUtils.setConfiguration('vgmChannel', newVal)
      if (newVal === 1 || this.isWse || this.isRongETong) {
        this.importFromContainer()
      }
    },
    'vgmInfo.thirdPartyCarrier': function(newVal) {
      this.handleSoNoInput()
    },
    'wseCache.vgmCarriers': function(newVal) {
      this.mergeVgmCarriersList()
    },
    'seaHouseCache.vgmCarriers': function(newVal) {
      this.mergeVgmCarriersList()
    }
  },
  async created() {
    await this.init()
    await this.loadData()
  },
  methods: {
    async loadData() {
      if (!this.job.uuid) {
        this.vgmInfo.boxHolder = 'COC'
        return
      }
      const vgmObj = await vgmList({ jobUuid: this.job.uuid }).then(res => res.data)
      if (vgmObj.vgmInfo && vgmObj.vgmInfo.length > 0) {
        this.vgmInfoList = vgmObj.vgmInfo
        this.vgmInfo = this.vgmInfoList[0]
        console.log('this.vgmInfo ', this.vgmInfo)
      } else {
        this.vgmInfo = new VgmInfo().fillDefaultValue().getData()
        this.vgmInfo.boxHolder = 'COC'
        this.vgmInfo.sendChannel = 0
        this.vgmInfo.vgmContainers = []
        this.vgmInfo.referenceNo = this.job.jobNo + '-1'
        this.vgmInfo.vgmContainers = []
        this.vgmInfoList = []
        this.vgmInfoList.push(this.vgmInfo)
      }
      // 初始化时默认选中第一行
      this.$nextTick(() => {
        const node = this.gridOptions.gridApi.getDisplayedRowAtIndex(0)
        if (node) {
          // 设置为选中行
          node.setSelected(true)
        }
      })
      this.job.vgmInfo = this.vgmInfo
      if (this.isEdit && this.job.uuid) {
        this.vgmInfoRaw = deepCopy(this.job.vgmInfo)
        this.$emit('syncData', { vgmInfo: this.vgmInfoRaw })
      }
    },
    async init() {
      if (!this.seaHouseCache.load) {
        this.thirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('seaHouse')
        this.seaHouseCache.portList = this.thirdPartyMappingUtil.getListByDataType('port')
        this.seaHouseCache.vgmCarriers = this.thirdPartyMappingUtil.getListByDataType('VGMCarrier')
        this.seaHouseCache.shPorts = this.thirdPartyMappingUtil.getListByDataType('SHPort')
        this.seaHouseCache.externalPorts = this.thirdPartyMappingUtil.getListByDataType('externalPort')
        this.seaHouseCache.weighingMethods = this.thirdPartyMappingUtil.getListByDataType('WeighingMethod')
        this.seaHouseCache.wharfs = this.thirdPartyMappingUtil.getListByDataType('wharf')
        this.seaHouseCache.load = true
      }
      if (!this.wseCache.load) {
        this.thirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('wse')
        this.wseCache.portList = this.thirdPartyMappingUtil.getListByDataType('port')
        this.wseCache.vgmCarriers = this.thirdPartyMappingUtil.getListByDataType('VGMCarrier')
        this.wseCache.shPorts = this.thirdPartyMappingUtil.getListByDataType('SHPort')
        this.wseCache.externalPorts = this.thirdPartyMappingUtil.getListByDataType('externalPort')
        this.wseCache.weighingMethods = this.thirdPartyMappingUtil.getListByDataType('WeighingMethod')
        this.wseCache.wharfs = this.thirdPartyMappingUtil.getListByDataType('wharf')
        this.wseCache.QDBoxes = this.thirdPartyMappingUtil.getListByDataType('box').filter(t => t.filterValue === 'qd')
        this.wseCache.QDYards = this.thirdPartyMappingUtil.getListByDataType('yard').filter(t => t.filterValue === 'qd')
        this.wseCache.load = true
      }
      if (!this.rongETongCache.load) {
        this.thirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('rongeTong')
        this.rongETongCache.portList = this.thirdPartyMappingUtil.getListByDataType('port')
        this.rongETongCache.vgmCarriers = this.thirdPartyMappingUtil.getListByDataType('VGMCarrier')
        this.rongETongCache.wharfs = this.thirdPartyMappingUtil.getListByDataType('wharf')
        this.rongETongCache.QDBoxes = this.thirdPartyMappingUtil.getListByDataType('box').filter(t => t.filterValue === 'qd' && t.cargoModuleName === 'vgm')
        this.rongETongCache.QDYards = this.thirdPartyMappingUtil.getListByDataType('yard')
        this.rongETongCache.load = true
      }
    },
    getSubmitData() {
      return {
        vgmInfo: this.vgmInfo,
        vgmInfoList: this.vgmInfoList,
        delVgmContainerKeys: this.delVgmContainerKeys,
        delvgmInfoUuids: this.delVgmKeys
      }
    },
    // 同步数据
    async syncInfo() {
      const vgmInfo = this.vgmInfo
      const hasSentManifest = this.hasSentManifest()
      if (hasSentManifest) {
      // 从预配页签同步
        const manifestInfo = this.job.manifestInfos[0]
        vgmInfo.vessel = manifestInfo.bargeVessel
        vgmInfo.voyage = manifestInfo.bargeVoyage
        vgmInfo.mbl = manifestInfo.mblNo
        if (manifestInfo.thirdPartyCarrier && vgmInfo.portOfLoading) {
          const field = 'vgmCarriers'
          const carrier = this.seaHouseCache[field].filter(item => item.code === manifestInfo.thirdPartyCarrier)
          if (carrier && carrier.length > 0) {
            vgmInfo.thirdPartyCarrier = manifestInfo.thirdPartyCarrier
          }
        }
        vgmInfo.thirdPartyCarrier = manifestInfo.thirdPartyCarrier
        this.syncTips()
        return
      }
      // 从基本页签同步
      vgmInfo.vessel = this.job.vessel
      vgmInfo.voyage = this.job.voyageFlight
      vgmInfo.mbl = this.job.mbl
      // 船公司，起运港
      const carrierId = this.job.carrierId
      if (carrierId > 0) {
        const carrier = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', carrierId)
        if (carrier != null) {
          const field = 'vgmCarriers'
          const carrierResults = this.seaHouseCache[field].filter(item => [item.code, item.chineseName].indexOf(carrier.englishName) > -1 ||
          [item.code, item.chineseName].indexOf(carrier.chineseName) > -1 ||
          [item.code, item.chineseName].indexOf(carrier.shortName) > -1 ||
          [item.code, item.chineseName].indexOf(carrier.cnShortName) > -1)
          if (carrierResults && carrierResults.length > 0) {
            vgmInfo.thirdPartyCarrier = carrierResults[0].code
          }
        }
      }
      const loadingPortCode = this.job.loadingPortCode
      if (loadingPortCode) {
        const seaPort = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', loadingPortCode)
        if (seaPort !== null) {
          const loadingPorts = this.cachePortList.filter(item => item.code === seaPort.code ||
          item.code === seaPort.chineseName ||
          item.code === seaPort.englishName)
          if (loadingPorts && loadingPorts.length > 0) {
            vgmInfo.portOfLoading = loadingPorts[0].code
          }
        }
      }
      this.syncTips()
    },
    syncTips() {
      if (!this.vgmInfo.portOfLoading) {
        this.portOfLoadingPlaceholder = this.$t('CargoMsg.Cargo_DeparturePortFieldNotFoundMatchingInfoWithSeaButlerPleaseCheck')
      }
      if (!this.vgmInfo.thirdPartyCarrier) {
        this.thirdPartyCarrierPlaceholder = this.$t('CargoMsg.Cargo_ShippingCompanyFieldNotFoundMatchingInfoWithSeaButlerPleaseCheck')
      }
    },
    // 预配是否发送过海管家
    hasSentManifest() {
      const manifestInfos = this.job.manifestInfos
      if (!manifestInfos || manifestInfos.length === 0) {
        return false
      }
      for (const manifestInfo of manifestInfos) {
        if (manifestInfo.seaHouseState !== '-1' && manifestInfo.seaHouseState !== '') {
          return true
        }
      }
      return false
    },
    sendVgm() {
      if (this.totalTime !== 60) {
        const content = this.$t('CargoMsg.Cargo_RepeatedlySendingVGMWithTheSameContainerTips', [this.totalTime]) // 这里解决60秒不见了的问题
        this.$message.warning(content)
        return
      }
      const allContainers = []
      for (const vgmInfo of this.vgmInfoList) {
        allContainers.push(...vgmInfo.vgmContainers)
      }
      const thisContainers = this.vgmInfo.vgmContainers
      const showConfirm = this.hasDuplicateContainerNo(allContainers, thisContainers)
      if (showConfirm) {
        this.$confirm(this.$t('CargoMsg.Cargo_Send_VGM_Reminder'), this.$t('SeaExport.tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_ContinueSending'),
          cancelButtonText: this.$t('common.btn.cancel'),
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          this.toSendVgm()
        })
      } else {
        this.toSendVgm()
      }
    },
    toSendVgm() {
      if (!this.vasChannel) {
        this.$message.warning(this.$t('SeaExport.ServiceNotActivated'))
      }
      this.loading = getLoading('sea-house-vgm')
      sendVgm({ vgmInfoKey: this.vgmInfo.uuid, vgmChannel: this.job.vgmChannel }).then(res => {
        this.loading.close()
        this.$message.success(this.$t('CargoMsg.Cargo_SendSuccess'))
        this.loadData()
        const clock = window.setInterval(() => {
          this.totalTime--
          this.content = this.totalTime + this.$t('CargoMsg.Cargo_ResendAfterS')
          if (this.totalTime < 0) { // 当倒计时小于0时清除定时器
            window.clearInterval(clock)
            this.totalTime = 60
          }
        }, 1000)
      }).catch(() => {
        this.loading.close()
      })
    },
    verifyForm() {
      const data = this.vgmInfo
      const inputMsg = this.$t('CargoMsg.Cargo_NotFilledIn')
      const selectMsg = this.$t('CargoMsg.Cargo_NotSelected')
      if (!data.portOfLoading) {
        this.$message.warning(this.$t('SeaExport.PortOfLoading') + selectMsg)
        return true
      }
      if (!data.thirdPartyCarrier) {
        this.$message.warning(this.$t('SeaExport.ShippingCompany') + selectMsg)
        return true
      }
      if (!data.mbl) {
        this.$message.warning('MBL NO.' + inputMsg)
        return true
      }
      if (this.isSHPort && !data.wharf) {
        this.$message.warning(this.$t('SeaExport.Wharf') + inputMsg)
        return true
      }
      if (this.showSoNo && !data.soNo) {
        this.$message.warning(this.$t('SeaExport.SoNo') + inputMsg)
        return true
      }
      if (this.showVesselAndVoyage && !data.vessel) {
        this.$message.warning(this.$t('SeaExport.Vessel') + inputMsg)
        return true
      }
      if (this.showVesselAndVoyage && !data.voyage) {
        this.$message.warning(this.$t('SeaExport.Voyage') + inputMsg)
        return true
      }
      if (this.showVgmCutOffDate && !data.vgmCutOffDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_VGMCutOffDate') + selectMsg)
        return true
      }
      if (!data.boxHolder) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ContainerHolder') + selectMsg)
        return true
      }
      // 校验箱货信息
      if (!data.vgmContainers || data.vgmContainers.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseMaintainCargoInfo'))
        return true
      }
      for (const container of data.vgmContainers) {
        if (!container.containerNo) {
          this.$message.warning(this.$t('SeaExport.ContainerNo') + inputMsg)
          return true
        }
        if (!container.vgmWeight) {
          this.$message.warning(this.$t('SeaExport.VgmWeight') + inputMsg)
          return true
        }
        if (!container.vgmWeightingMethod) {
          this.$message.warning(this.$t('SeaExport.VgmWeighingMethod') + selectMsg)
          return true
        }
        // if (!container.vgmLiabilityCompany) {
        //   this.$message.warning(this.$t('SeaExport.VGMLLC') + inputMsg)
        //   return true
        // }
        // if (this.mustInputVGMWeightAddress && !container.weighingAddress) {
        //   this.$message.warning(this.$t('SeaExport.VGMWeightAddress') + inputMsg)
        //   return true
        // }
        // if (!container.vgmAutoGraph) {
        //   this.$message.warning(this.$t('SeaExport.VGMSignature') + inputMsg)
        //   return true
        // }
      }
    },
    addVgmContainer() {
      const vgmContainer = new VgmContainer().fillDefaultValue().getData()
      vgmContainer.seaHouseState = '-1'
      vgmContainer.vgmWeightingMethod = 'SM2'
      vgmContainer.vgmInfoUuid = this.vgmInfo.uuid
      if (!this.vgmInfo.vgmContainers) {
        this.vgmInfo.vgmContainers = []
      }
      this.vgmInfo.vgmContainers.push(vgmContainer)
      this.vgmGrid.gridOptions.gridApi.setRowData(this.vgmInfo.vgmContainers) // 刷新
    },
    removeVgmContainer() {
      const rows = this.vgmGrid.gridOptions.gridApi.getSelectedRows()
      if (rows && rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (this.vgmInfo.vgmContainers) {
        for (let i = this.vgmInfo.vgmContainers.length - 1; i >= 0; --i) {
          const row = this.vgmInfo.vgmContainers[i]
          if (rows.includes(row)) {
            if (row.uuid) {
              this.delVgmContainerKeys.push(row.uuid)
            }
            this.vgmInfo.vgmContainers.splice(i, 1)
          }
        }
      }
      this.vgmGrid.gridOptions.gridApi.setRowData(this.vgmInfo.vgmContainers) // 刷新
    },
    importFromContainer(isBtn = false, isJobToVgm = false) {
    // 同步箱货信息
    // 获取业务的箱货信息
      const containers = this.job.containers
      if (!containers || containers.length === 0) {
        if (isBtn) {
          this.$message.info(this.$t('SeaExport.TherePleaseEnterItTab'))
        }
        return
      }
      const vgmContainers = this.vgmInfo.vgmContainers
      const vgmContainerMap = {}
      if (vgmContainers && vgmContainers.length > 0) {
        for (const vgmContainer of vgmContainers) {
          vgmContainerMap[vgmContainer.containerNo] = vgmContainer
        }
      }
      for (const container of containers) {
        if (!vgmContainerMap.hasOwnProperty(container.containerNo) && container.containerNo) {
          const newContainer = new VgmContainer().fillDefaultValue().getData()
          newContainer.containerNo = container.containerNo
          newContainer.vgmWeight = container.vGMWeight
          newContainer.vgmWeightingMethod = 'SM2'
          newContainer.weighingAddress = container.vGMWeightingPlace
          newContainer.containerType = container.eqSize + container.eqType
          vgmContainers.push(newContainer)
        }
        // 有对应的数据时
        if (vgmContainerMap.hasOwnProperty(container.containerNo)) {
          const vgmContainer = vgmContainerMap[container.containerNo]
          vgmContainer.vgmWeight = container.vGMWeight
          vgmContainer.vgmWeightingMethod = 'SM2'
          vgmContainer.weighingAddress = container.vGMWeightingPlace
        }
      }
      this.$nextTick(() => {
        this.vgmGrid.gridOptions.api.refreshCells({ force: true })
      })
    },
    onDownloadTemplate() {
      ExportUtils.downloadTemplateFile('SeaHouse-VGMTemplate.xlsx', 'booking')
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    uploadSuccess(response, file, fileList) {
      const data = response.data
      if (typeof data === 'string') {
        this.$message.warning(data)
        return
      }
      this.$message.success(this.$t('SeaExport.ImportSuccess'))
      // 数据同步
      if (!this.vgmInfo) {
        this.addVgmInfo()
      }
      if (this.isWse || this.isRongETong) {
        commonUtils.objCopyWithFields(data, this.vgmInfo, ['portOfLoading', 'mbl', 'vessel', 'voyage', 'wharf', 'soNo', 'vgmCutOffDate'])
        if (data.vgmContainers && data.vgmContainers.length > 0) {
          for (const item of data.vgmContainers) {
            item.vgmWeightingMethod = 'SM2'
          }
        }
      } else {
        commonUtils.objCopyWithFields(data, this.vgmInfo, ['portOfLoading', 'mbl', 'vessel', 'voyage', 'wharf', 'soNo', 'boxHolder', 'vgmCutOffDate'])
      }
      // 删除原数据
      if (this.vgmInfo.vgmContainers && this.vgmInfo.vgmContainers.length > 0) {
        const delVgmContainerKeys = []
        for (const item of this.vgmInfo.vgmContainers) {
          if (item.uuid) {
            delVgmContainerKeys.push(item.uuid)
          }
        }
        this.delVgmContainerKeys = delVgmContainerKeys
      }
      this.$nextTick(() => { // 延后同步
        this.vgmInfo.thirdPartyCarrier = data.thirdPartyCarrier
      })
      this.vgmInfo.vgmContainers = data.vgmContainers
      if (this.isEdit && this.job.uuid) {
        this.vgmInfoRaw.vgmContainers = deepCopy(this.vgmInfo.vgmContainers)
        this.$emit('syncData', { vgmInfo: this.vgmInfoRaw })
      }
    },
    async onOperationGuide() {
      await this.mergeVgmCarriersList()
      this.vgmServiceGuide.visible = true
    },
    showLog() {
      this.vgmLog.visible = true
    },
    linkQQ() {
      window.open('https://wpa1.qq.com/9ASmsPnZ?_type=wpa&qidian=true')
    },
    handleMblInput() {
      let value = this.vgmInfo.mbl
      // 将输入内容转换为大写字母
      value = value.toUpperCase()
      // 过滤掉非大写字母、数字和“-”字符
      value = value.replace(/[^A-Z0-9-]/g, '')
      // 限制输入长度为 6 到 30 个字符
      if (value.length > 30) {
        value = value.substr(0, 30)
      }
    },
    changeContainerNo(params) {
      const value = params.newValue
      const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      if (value.length === 11) {
        for (let i = 0; i < 4; i++) {
          if (letters.indexOf(value.charAt(i)) === -1) {
            this.$message.warning(this.$t('CargoMsg.Cargo_TheBoxNumberMustBe'))
            return
          }
        }
        const lastSeven = value.substr(4)
        if (isNaN(lastSeven) || lastSeven.length !== 7) {
          this.$message.warning(this.$t('CargoMsg.Cargo_TheBoxNumberMustBe'))
          return
        }
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_TheBoxNumberMustBe'))
      }
    },
    handleSoNoInput() {
      if (this.vgmInfo.thirdPartyCarrier === 'WHL') {
        this.toUpperCase('soNo')
        return
      }
      if (this.vgmInfo.thirdPartyCarrier === 'HLC' || this.vgmInfo.thirdPartyCarrier === 'HLC/HPL') {
        let value = this.vgmInfo.soNo
        value = value.replace(/[^0-9]/g, '')
        this.vgmInfo.soNo = value
        return
      }
    },
    toUpperCase(field) {
      const value = this.vgmInfo[field]
      // 过滤掉非大写字母、数字和“-”字符
      if (field === 'vessel') {
        if (this.rongETongCache) {
          this.vgmInfo[field] = value ? value.replace(/[^a-zA-Z0-9 .-]/g, '').toUpperCase().substr(0, 70) : ''
        } else {
          this.vgmInfo[field] = value ? value.replace(/[^a-zA-Z0-9 _.-]/g, '').toUpperCase().substr(0, 70) : ''
        }
        return
      }
      if (field === 'voyage') {
        this.vgmInfo[field] = value ? value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase().substr(0, 70) : ''
        return
      }
      this.vgmInfo[field] = value ? value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase() : ''
    },
    loadWharf() {
      if (this.isWse || this.isRongETong) return
      if (this.vgmInfo.vessel && this.vgmInfo.voyage && this.isSHPort) {
        // 请求获取码头接口
        querySeaHouseWharf({ vessel: this.vgmInfo.vessel, voyage: this.vgmInfo.voyage }).then(res => {
          if (res.data) {
            const wharfs = this.seaHouseCache.wharfs.filter(item => item.chineseName === res.data)
            if (wharfs && wharfs.length > 0) {
              this.vgmInfo.wharf = wharfs[0].code
              this.$message.warning(this.$t('CargoMsg.Cargo_LoadWharfTips'))
            }
          }
        })
      }
    },
    changeCarrier(p) {
      if (!p.value) {
        this.thirdPartyCarrierPlaceholder = this.$t('CargoMsg.Cargo_PleaseSelect')
      }
      this.vgmInfo.thirdPartyCarrier = p.value
      if (this.vgmInfo.portOfLoading === '上海' && this.vgmInfo.thirdPartyCarrier === 'APL') {
        this.showVGMWeightAddress = true
      } else {
        this.showVGMWeightAddress = false
      }
    },
    changePort(p) {
      if (!p.value) {
        this.portOfLoadingPlaceholder = this.$t('CargoMsg.Cargo_PleaseSelect')
      }
      this.vgmInfo.portOfLoading = p.value
      if (this.vgmInfo.portOfLoading === '上海' && this.vgmInfo.thirdPartyCarrier === 'APL') {
        this.showVGMWeightAddress = true
      } else {
        this.showVGMWeightAddress = false
      }
      this.vgmInfo.thirdPartyCarrier = ''
    },
    changeVGMSignature(params) {
      const value = params.newValue
      params.data.vgmAutoGraph = value ? value.replace(/[^A-Z]/g, '').toUpperCase().substring(0, 20) : ''
      this.vgmGrid.gridOptions.api.refreshCells({ force: true })
    },
    changeVGMWeightAddress(params) {
      let value = params.newValue
      // 过滤非半角字符和特殊字符
      value = value.replace(/[^\x00-\xff]/g, '')
      value = value.replace(/[+'":]/g, '')
      // 限制输入长度为 140 个字符
      if (value.length > 140) {
        value = value.substr(0, 140)
      }
      // 更新数据模型
      params.data.weighingAddress = value.toUpperCase()
      this.vgmGrid.gridOptions.api.refreshCells({ force: true })
    },
    changeVgmWeighingPlace(params) {
      params.data.vgmWeighingPlace = params.newValue
      this.vgmGrid.gridOptions.api.refreshCells({ force: true })
    },
    changeVgmLiabilityCompany(params) {
      let value = params.newValue.toUpperCase()
      // 过滤非大写字母、数字、空格、“.”、“,”、“()”、“&”和“-”字符
      value = value.replace(/[^A-Z0-9 .,()&-]/g, '')
      params.data.vgmLiabilityCompany = value.length > 70 ? value.substr(0, 70) : value
      this.vgmGrid.gridOptions.api.refreshCells({ force: true })
    },
    changeVgmWeight(params) {
      const value = params.newValue
      if (value > 10000000 || isNaN(value)) {
        params.data.vgmWeight = 9999999.99
        this.vgmGrid.gridOptions.api.refreshCells({ force: true })
      }
    },
    changeVgmGrossWeight(params) {
      const value = params.newValue
      if (value > 100000 || isNaN(value)) {
        params.data.grossWeight = 99999.999
        this.vgmGrid.gridOptions.api.refreshCells({ force: true })
      }
    },
    changeVgmTareWeight(params) {
      const value = params.newValue
      if (value > 100000 || isNaN(value)) {
        params.data.tareWeight = 99999.999
        this.vgmGrid.gridOptions.api.refreshCells({ force: true })
      }
    },
    commandHandle(command) {
      switch (command) {
        case this.$t('SeaExport.DownloadCWTemplate'):
          ExportUtils.downloadTemplateFile('VGMTemplate.xlsx', 'booking')
          break
      }
    },
    mergeVgmCarriersList() {
      const wseVgmCarriers = this.wseCache.vgmCarriers
      const seaVgmCarriers = this.seaHouseCache.vgmCarriers
      const retVgmCarriers = this.rongETongCache.vgmCarriers

      // 使用 Map 来确保唯一性
      const vgmCarriersMap = new Map()

      // 将 wseCache.portList 添加到 Map 中
      wseVgmCarriers.forEach(vgmCarrier => {
        vgmCarriersMap.set(vgmCarrier.name, vgmCarrier)
      })

      // 将 seaHouseCache.portList 中不重复的添加到 Map 中
      seaVgmCarriers.forEach(vgmCarrier => {
        if (!vgmCarriersMap.has(vgmCarrier.name)) {
          vgmCarriersMap.set(vgmCarrier.name, vgmCarrier)
        }
      })

      // 将 rongETongCache.portList 中不重复的添加到 Map 中
      retVgmCarriers.forEach(vgmCarrier => {
        if (!vgmCarriersMap.has(vgmCarrier.name)) {
          vgmCarriersMap.set(vgmCarrier.name, vgmCarrier)
        }
      })

      // 转换回数组
      this.mergeVgmCarriers = Array.from(vgmCarriersMap.values())
    },
    // 解析箱型箱量
    resolveContainerType(params) {
      if (params.data.containerType) {
        let target
        if (params.value.includes('HQ') || params.value.includes('HC')) {
          target = this.wseCache.QDBoxes.find((data) => data.code === params.value)
          if (target) {
            return target.name
          } else {
            if (params.value.includes('HQ')) {
              const value = params.value.replace('HQ', 'HC')
              target = this.wseCache.QDBoxes.find((data) => data.code === value)
              if (target) {
                return target.name
              }
            } else if (params.value.includes('HC')) {
              const value = params.value.replace('HC', 'HQ')
              target = this.wseCache.QDBoxes.find((data) => data.code === value)
              if (target) {
                return target.name
              }
            }
          }
        } else {
          target = this.wseCache.QDBoxes.find((data) => data.code === params.value)
          if (target) {
            return target.name
          }
        }
        return params.value
      }
      return ''
    },
    // 用来判断当前发送的箱子在所有箱子中是否存在箱子重复的
    hasDuplicateContainerNo(allContainers, thisContainers) {
      // 创建一个 Map 来统计 allContainers 中每个 ContainerNo 出现的次数
      const containerNoCount = new Map()

      for (const container of allContainers) {
        const no = container.containerNo
        containerNoCount.set(no, (containerNoCount.get(no) || 0) + 1)
      }
      // 检查 thisContainers 中是否有任何一个 ContainerNo 在 allContainers 中出现了超过一次
      for (const container of thisContainers) {
        const no = container.containerNo
        if (containerNoCount.get(no) > 1) {
          return true
        }
      }

      return false
    },
    generateNextReferenceNo(jobNo, vgmInfoList = []) {
      // 找到所有以 jobNo- 开头，后面是纯数字的编号
      const pattern = new RegExp(`^${jobNo.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}-(\\d+)$`)
      let maxIndex = 0

      for (const vgmInfo of vgmInfoList) {
        const match = vgmInfo.referenceNo.match(pattern)
        if (match) {
          const index = parseInt(match[1], 10)
          if (index > maxIndex) {
            maxIndex = index
          }
        }
      }

      return `${jobNo}-${maxIndex + 1}`
    },
    onGridReady() {
      // 检查是否有数据
      if (this.vgmInfoList && this.vgmInfoList.length > 0) {
        // 延迟执行，确保grid已完全渲染
        this.$nextTick(() => {
          const node = this.gridOptions.gridApi.getDisplayedRowAtIndex(0)
          if (node) {
            // 设置为选中行
            node.setSelected(true)
          }
        })
      }
    },
    // 选中vgm数据
    clickedVgmInfo(event) {
      this.vgmInfo = event.data
    },

    // 标记最后一条选中行
    markVgmInfo() {
      if (this.vgmInfoList && this.vgmInfoList.length > 0) {
        const maxIndex = this.vgmInfoList.length - 1
        this.$nextTick(() => {
          const node = this.gridOptions.gridApi.getDisplayedRowAtIndex(maxIndex)
          if (node) {
            // 设置为选中行
            node.setSelected(true)
          }
        })
        this.vgmInfo = this.vgmInfoList[maxIndex]
      }
    },

    addVgmInfo() {
      if (!this.vgmInfoList) {
        this.vgmInfoList = []
      }
      // 添加 VGM 信息
      let vgmInfo = null
      if (this.vgmInfoList && this.vgmInfoList.length > 0) {
        vgmInfo = { ...this.vgmInfoList[this.vgmInfoList.length - 1] }
      } else {
        vgmInfo = new VgmInfo().fillDefaultValue().getData()
      }
      vgmInfo.receiptStatus = ''
      vgmInfo.uuid = ''
      vgmInfo.boxHolder = 'COC'
      vgmInfo.referenceNo = this.generateNextReferenceNo(this.job.jobNo, this.vgmInfoList)
      vgmInfo.vgmContainers = []
      this.vgmInfoList.push(vgmInfo)
      this.gridOptions.gridApi.setRowData(this.vgmInfoList)
      // 选中最新一行
      this.markVgmInfo()
    },
    deleteVgmInfo() {
      const rows = this.gridOptions.gridApi.getSelectedRows()
      if (rows && rows.length === 0) {
        return
      }
      if (this.vgmInfoList) {
        for (let i = this.vgmInfoList.length - 1; i >= 0; --i) {
          const row = this.vgmInfoList[i]
          if (rows.includes(row)) {
            if (row.uuid) {
              this.delVgmKeys.push(row.uuid)
              // 删除下面所有的 VgmContainer
              if (row.vgmContainers) {
                for (const vgmContainer of row.vgmContainers) {
                  if (vgmContainer.uuid) {
                    this.delVgmContainerKeys.push(vgmContainer.uuid)
                  }
                }
              }
            }
            this.vgmInfoList.splice(i, 1)
          }
        }
      }
      if (this.vgmInfoList && this.vgmInfoList.length > 0) {
        // 标记最后一行
        this.markVgmInfo()
      } else {
        this.vgmInfo = new VgmInfo().fillDefaultValue().getData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .sea-house-vgm {
    height: 100%;
    /deep/ .required-label .el-form-item__label {
      color: #1F75D5 !important;
    }

    /deep/ .required-label .ag-header-cell-text {
      color: #1F75D5 !important;
    }

    .el-form {
      /deep/ .el-form-item {
        .el-form-item__content {
          width: 220px;

          .el-input__inner {
            width: 220px;

            &.short {
              width: 155px;
            }
          }
        }
      }

      .el-radio-group {
        width: 300px;
      }

      .input-tips {
        margin: 4px;
        line-height: 13px;
        color: #5a5e66;
      }
    }
    .main-content {
      overflow: auto !important;
    }
  }

  .sea-house-tip {
    position: fixed;
    right: 1%;
    top: 40%;
    width: 60px;
    height: 60px;
    cursor: pointer;

    img {
      width: 100%;
    }
  }
</style>
